import React from 'react';

// Extracted verbatim from Landing.jsx's main tabbed portal (previously the
// `userType === 'guest'` block). Behavior/markup unchanged — both the
// CapitaLand ODX (Room Guest / ASR Member) and generic Room Number/Last Name
// branches are preserved exactly. See authRegistry.js for how this is wired.
// roomPlaceholder / lastNameHint are optional wording a builder page can set
// (LandingPageRenderer.jsx); left out, the form reads exactly as before.
const PMSLoginFields = ({
    portalData,
    formData,
    handleInputChange,
    odxLoginType,
    setOdxLoginType,
    showGenericPw,
    setShowGenericPw,
    primaryColor,
    roomPlaceholder,
    lastNameHint,
}) => (
    <div className="animate-fade-in">

        {/* CapitaLand ODX: Room Guest or ASR Member login */}
        {portalData?.pmsProvider === 'capitaland' ? (<>
            {/* Login type selector */}
            <div className="form-group">
                <select
                    className="asr-select"
                    value={odxLoginType}
                    onChange={e => setOdxLoginType(e.target.value)}
                >
                    <option value="room">Room Guest</option>
                    <option value="asr">ASR Member</option>
                </select>
            </div>

            {odxLoginType === 'room' ? (<>
                <div className="form-group">
                    <label>Room Number</label>
                    <div className="input-with-icon">
                        <i className="fas fa-door-open"></i>
                        <input
                            type="text"
                            name="roomNumber"
                            className="input"
                            placeholder={roomPlaceholder || 'Room Number'}
                            value={formData.roomNumber || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                </div>
                <div className="form-group">
                    <label>Last Name</label>
                    <div className="input-with-icon">
                        <i className="fas fa-user"></i>
                        <input
                            type="text"
                            name="lastName"
                            className="input"
                            placeholder="Guest Last Name"
                            value={formData.lastName || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    {lastNameHint && <p className="field-hint">{lastNameHint}</p>}
                </div>
            </>) : (<>
                <div className="form-group">
                    <label>ASR Member Email</label>
                    <div className="input-with-icon">
                        <i className="fas fa-envelope"></i>
                        <input
                            type="email"
                            name="asrEmail"
                            className="input"
                            placeholder="Enter ASR Member Email"
                            value={formData.asrEmail || ''}
                            onChange={handleInputChange}
                            autoComplete="username"
                            required
                        />
                    </div>
                </div>
                <div className="form-group">
                    <label>ASR Member Password</label>
                    <div className="input-with-icon input-with-toggle">
                        <i className="fas fa-lock"></i>
                        <input
                            type={showGenericPw ? 'text' : 'password'}
                            name="asrPassword"
                            className="input"
                            placeholder="Enter ASR Member Password"
                            value={formData.asrPassword || ''}
                            onChange={handleInputChange}
                            autoComplete="current-password"
                            required
                        />
                        <button
                            type="button"
                            className="pw-toggle-btn"
                            onClick={() => setShowGenericPw(v => !v)}
                        >
                            {showGenericPw ? 'Hide' : 'Show'}
                        </button>
                    </div>
                </div>
                <div className="asr-signup-link">
                    <a href="https://discoverasr.com" target="_blank" rel="noopener noreferrer" style={{ color: primaryColor }}>
                        Click here to sign up for ASR
                    </a>
                </div>
            </>)}
        </>) : (<>
            <div className="form-group">
                <label>Room Number</label>
                <div className="input-with-icon">
                    <i className="fas fa-door-open"></i>
                    <input
                        type="text"
                        name="roomNumber"
                        className="input"
                        placeholder={roomPlaceholder || 'Room #'}
                        required
                        value={formData.roomNumber}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
            <div className="form-group">
                <label>Last Name</label>
                <div className="input-with-icon">
                    <i className="fas fa-user"></i>
                    <input
                        type="text"
                        name="lastName"
                        className="input"
                        placeholder="Guest Last Name"
                        required
                        value={formData.lastName}
                        onChange={handleInputChange}
                    />
                </div>
                {lastNameHint && <p className="field-hint">{lastNameHint}</p>}
            </div>
        </>)}
    </div>
);

export default PMSLoginFields;
